import lozad from 'lozad';
import Cookies from 'js-cookie';
import {
    getDLProductFromProductDTO,
    getDLProductFromCartProductDTO,
    getProductsArrayFromProductsDTO,
} from '@js/utilities/datalayerHelpers';
import { handleJsonParse } from '@js/utilities/handleJson';
import '@js/datalayer/dlProduct';

const smOwners = {
    pl: 'r.golebski@savicki.pl',
    cz: 'r.golebski+cz@savicki.pl',
    sk: 'r.golebski+sk@savicki.pl',
    ro: 'r.golebski+ro@savicki.pl',
};

/**
 * @GLOBAL
 * global params are being sent from boot.js file
 */

/**
 * @FORMS
 */

window.addEventListener('forms.success', (e) => {
    const dataLayerString = e.detail.form.getAttribute('datalayer');

    const { payload } = e.detail;

    if (!dataLayerString) {
        return;
    }

    const d = handleJsonParse(dataLayerString);

    const obj = {
        ...d,
        email: payload?.email,
        phone: payload?.phone,
    };

    if (d) {
        window.dataLayer.push(obj);
    }
});

document.addEventListener('livewire:initialized', () => {
    window.Livewire.on('form.success.livewire', (payload) => {
        const data = payload?.[0];

        if (!data) {
            return;
        }

        console.log('smClient:', data.smClient);

        if (data?.smClient) {
            Cookies.set('smclient', data.smClient);
        }

        window.dataLayer.push(data);
    });
});

/**
 * @LISTING
 * view_item_list
 * select_item
 */
window.addEventListener('datalayer.view_item_list', (e) => {
    const listingData = handleJsonParse(e.detail.productsData);
    const categoryData = handleJsonParse(e.detail.categoryData);

    if (!listingData || !categoryData) {
        return;
    }

    const products = listingData.map((product, index) => ({
        ...getDLProductFromProductDTO(product),
        item_list_id: categoryData.id,
        item_list_name: categoryData.translation.name,
        index: index,
    }));

    window.dataLayer.push({
        ecommerce: null,
    });
    window.dataLayer.push({
        event: 'view_item_list',
        ecommerce: {
            item_list_id: categoryData.id,
            item_list_name: categoryData.translation.name,
            items: products,
        },
    });

    const productItemElements = [...document.querySelectorAll('.js-product-item')];

    productItemElements.forEach((el) => {
        el.addEventListener('click', (ev) => {
            if (!ev.target.closest('a')) {
                return;
            }

            const selectedProduct = products.find((p) => p.item_id === el.dataset.productId);

            if (selectedProduct) {
                window.dataLayer.push({
                    ecommerce: null,
                });
                window.dataLayer.push({
                    event: 'select_item',
                    ecommerce: {
                        item_list_id: categoryData.id,
                        item_list_name: categoryData.translation.name,
                        items: [selectedProduct],
                    },
                });
            }
        });
    });
});

/**
 * @PRODUCT
 * view_item
 */
window.addEventListener('datalayer.view_item', (e) => {
    const product = handleJsonParse(e.detail.product);

    if (!product) {
        return;
    }

    const dlProduct = getDLProductFromProductDTO(product);

    window.dataLayer.push({
        ecommerce: null,
    });
    window.dataLayer.push({
        event: 'view_item',
        ecommerce: {
            currency: window.config.currency.code,
            value: Number(dlProduct.quantity || 1) * Number(product.price.value),
            items: [dlProduct],
        },
    });
});

/**
 * @ADD_TO_CART
 */
window.addEventListener('datalayer.add_to_cart', (e) => {
    // TODO: temporary fix for productData being stringified twice (livewire/remote-content issue)
    const product = e.detail.productData;
    if (!product) {
        return;
    }

    const dlData = {
        event: 'add_to_cart',
        ecommerce: {
            currency: window.config.currency.code,
            value: Number(product.quantity || 1) * Number(product.price.value),
            items: [getDLProductFromCartProductDTO(product)],
        },
    };

    window.dataLayer.push({
        ecommerce: null,
    });
    window.dataLayer.push(dlData);

    if (typeof window.sm === 'function') {
        const objToSend = {
            owner: smOwners[window.config?.language?.region?.toLowerCase()],
            contactId: Cookies.get('smclient') || Cookies.get('smuuid'),
            email: Cookies.get('smemail'),
            date: Date.now(),
            contactExtEventType: 'CART',
            location: `savicki_${window.config?.language?.region?.toLowerCase() || 'N/A'}`,
            products: `${product.product_id}`,
            value: product.price?.value || '',
        };

        console.log(objToSend);

        window.sm('extEvent', objToSend);
    }
});

window.addEventListener('datalayer.add_to_cart_upsell', (e) => {
    const product = handleJsonParse(e.detail.productData);

    if (!product) {
        return;
    }

    window.dataLayer.push({
        ecommerce: null,
    });
    window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
            currency: window.config.currency.code,
            value: Number(product.quantity || 1) * Number(product.price.value),
            items: [getDLProductFromProductDTO(product)],
        },
    });
});

/**
 * @REMOVE_FROM_CART
 */
window.addEventListener('datalayer.remove_from_cart', (e) => {
    const product = e.detail.productData;

    if (!product) {
        return;
    }

    const dlData = {
        event: 'remove_from_cart',
        ecommerce: {
            currency: window.config.currency.code,
            value: Number(product.quantity || 1) * Number(product.price.value),
            items: [getDLProductFromCartProductDTO(product)],
        },
    };

    window.dataLayer.push({
        ecommerce: null,
    });
    window.dataLayer.push(dlData);
});

/**
 * @VIEW_CART - odpada ze wzgledu na onepagecheckout
 */
window.addEventListener('datalayer.view_cart', (e) => {
    const { products } = e.detail;
    // const products = handleJsonParse(e.detail.products);
    const totalPrice = Number(e.detail.totalPrice);

    if (!products) {
        return;
    }

    const dlData = {
        event: 'view_cart',
        ecommerce: {
            currency: window.config.currency.code,
            value: totalPrice,
            items: getProductsArrayFromProductsDTO(products).map((el, index) => ({
                ...getDLProductFromCartProductDTO(el),
                index: index,
            })),
        },
    };

    window.dataLayer.push({
        ecommerce: null,
    });
    window.dataLayer.push(dlData);
});

/**
 * @BEGIN_CHECKOUT
 */
window.addEventListener('datalayer.begin_checkout', (e) => {
    const { products } = e.detail;
    const totalPrice = Number(e.detail.totalPrice);
    const { coupon } = e.detail;

    if (!products) {
        return;
    }

    const dlData = {
        event: 'begin_checkout',
        ecommerce: {
            currency: window.config.currency.code,
            value: totalPrice,
            coupon: coupon || null,
            items: getProductsArrayFromProductsDTO(products).map((el, index) => ({
                ...getDLProductFromCartProductDTO(el),
                index,
            })),
        },
    };

    window.dataLayer.push({
        ecommerce: null,
    });
    window.dataLayer.push(dlData);
});

/**
 * @ADD_PAYMENT_INFO
 */
window.addEventListener('datalayer.add_payment_info', (e) => {
    const { coupon, paymentType, products, value } = e.detail;

    const dlData = {
        event: 'add_payment_info',
        ecommerce: {
            currency: window.config.currency.code,
            value: Number(value),
            payment_type: paymentType,
            coupon: coupon || null,
            items: getProductsArrayFromProductsDTO(products).map((el, index) => ({
                ...getDLProductFromCartProductDTO(el),
                index,
            })),
        },
    };

    window.dataLayer.push({
        ecommerce: null,
    });
    window.dataLayer.push(dlData);
});

/**
 * @ADD_SHIPPING_INFO
 */
window.addEventListener('datalayer.add_shipping_info', (e) => {
    const { coupon, shippingTier, products, value } = e.detail;

    const dlData = {
        event: 'add_shipping_info',
        ecommerce: {
            currency: window.config.currency.code,
            value: Number(value),
            shipping_tier: shippingTier,
            coupon: coupon || null,
            items: getProductsArrayFromProductsDTO(products).map((el, index) => ({
                ...getDLProductFromCartProductDTO(el),
                index,
            })),
        },
    };

    window.dataLayer.push({
        ecommerce: null,
    });
    window.dataLayer.push(dlData);
});

/**
 * @VIEW_ORDER_SUMMARY
 */
window.addEventListener('datalayer.view_order_summary', () => {
    window.dataLayer.push({
        event: 'view_order_summary',
    });
});

/**
 * @PURCHASE
 */
window.addEventListener('datalayer.purchase', (e) => {
    const { products } = e.detail;
    const totalPrice = Number(e.detail.totalPrice);
    const { transactionId } = e.detail;
    const { coupon } = e.detail;

    const dlData = {
        event: 'purchase',
        ecommerce: {
            currency: window.config.currency.code,
            value: totalPrice || '',
            transaction_id: transactionId || '',
            coupon: coupon || null,
            items: getProductsArrayFromProductsDTO(products).map((el, index) => ({
                ...getDLProductFromCartProductDTO(el),
                index,
            })),
            phone: e.detail.phone || null,
            email: e.detail.email || null,
        },
    };

    console.log({ dlData });

    window.dataLayer.push({
        ecommerce: null,
    });
    window.dataLayer.push(dlData);

    if (typeof window.sm === 'function') {
        const objToSend = {
            owner: smOwners[window.config?.language?.region?.toLowerCase()],
            contactId: Cookies.get('smclient') || Cookies.get('smuuid'),
            email: e.detail.email || Cookies.get('smemail'),
            date: Date.now(),
            contactExtEventType: 'PURCHASE',
            products: getProductsArrayFromProductsDTO(products)
                .map((el) => el.purchasable?.id)
                .join(', '),
            value: totalPrice || '',
        };

        console.log(objToSend);
        // console.log(objToSend.products);

        window.sm('extEvent', objToSend);
    }
});

/**
 * @VIEW_PROMOTION
 * @SELECT_PROMOTION
 */
const promotionObserver = lozad('.js-datalayer-promotion-view', {
    load: (el) => {
        const dlData = handleJsonParse(el.getAttribute('datalayer'));

        if (!dlData) {
            return;
        }

        window.dataLayer.push({
            ecommerce: null,
        });
        window.dataLayer.push({ ...dlData });
    },
});

const selectPromotionListener = () => {
    const selectPromotionElements = [
        ...document.querySelectorAll('.js-datalayer-promotion-select'),
    ].filter((el) => !el.dataset.selectPromotionInitialized);

    selectPromotionElements.forEach((el) => {
        el.addEventListener('click', () => {
            const dlData = handleJsonParse(el.getAttribute('datalayer'));

            if (dlData) {
                window.dataLayer.push({
                    ecommerce: null,
                });
                window.dataLayer.push({ ...dlData });
            }
        });

        el.dataset.selectPromotionInitialized = true;
    });
};

['DOMContentLoaded', 'RemoteContentLoaded'].forEach((ev) => {
    window.addEventListener(ev, () => {
        promotionObserver.observe();
        selectPromotionListener();
    });
});

/**
 * @PRODUCT_AVAILABILITY
 */

/**
 * @CLICK
 */
const clickDatalayerListener = () => {
    const clickableElements = [...document.querySelectorAll('.js-click-send-datalayer')].filter(
        (el) => !el.dataset.clickDatalayerInitialized
    );

    clickableElements.forEach((el) => {
        el.addEventListener('click', () => {
            const dlString = handleJsonParse(el.getAttribute('datalayer'));

            if (dlString) {
                window.dataLayer.push({ ...dlString });
            }
        });

        el.dataset.clickDatalayerInitialized = true;
    });
};

['DOMContentLoaded', 'RemoteContentLoaded', 'livewire.component.rendered'].forEach((ev) => {
    window.addEventListener(ev, () => {
        clickDatalayerListener();
    });
});

/**
 * @CHANGE
 */
let changeTimeout = null;

const changeDatalayerListener = () => {
    const changeableElements = [...document.querySelectorAll('.js-change-send-datalayer')].filter(
        (el) => !el.dataset.changeDatalayerInitialized
    );

    changeableElements.forEach((el) => {
        el.addEventListener('change', () => {
            clearTimeout(changeTimeout);
            changeTimeout = setTimeout(() => {
                const dlString = handleJsonParse(decodeURIComponent(el.getAttribute('datalayer')));

                if (dlString) {
                    if (!dlString.option_value) {
                        dlString.option_value = el.options[el.selectedIndex].dataset.datalayerLabel;
                    }

                    window.dataLayer.push({ ...dlString });
                }
            }, 100);
        });

        el.dataset.changeDatalayerInitialized = true;
    });
};

['DOMContentLoaded', 'RemoteContentLoaded', 'livewire.component.rendered'].forEach((ev) => {
    window.addEventListener(ev, () => {
        changeDatalayerListener();
    });
});

/**
 * @INIT
 */
const initDatalayerListener = () => {
    const elements = [...document.querySelectorAll('.js-init-send-datalayer')].filter(
        (el) => !el.dataset.initDatalayerInitialized
    );

    elements.forEach((el) => {
        const datalayerContent = handleJsonParse(el.getAttribute('datalayer'));

        if (datalayerContent) {
            window.dataLayer.push({ ...datalayerContent });
        }

        el.dataset.initDatalayerInitialized = true;
    });
};

['auth.checked', 'RemoteContentLoaded', 'livewire.component.rendered'].forEach((ev) => {
    window.addEventListener(ev, () => {
        initDatalayerListener();
    });
});

window.addEventListener('datalayer.form_step', (e) => {
    const datalayerContent = {
        event: e.detail.datalayer.event,
        form_id: e.detail.datalayer.form_id,
        step_id: e.detail.currentStep,
        step_name: e.detail.datalayer.steps_data[e.detail.currentStep]?.name || '',
    };

    window.dataLayer.push({ ...datalayerContent });
});

document.addEventListener('DOMContentLoaded', () => {
    if (typeof window.LC_API !== 'undefined') {
        const dlContent = {
            event: 'initiate_chat',
        };

        if (window.PRODUCT_ID) {
            dlContent.item_id = window.PRODUCT_ID || '';
            dlContent.item_name = window.PRODUCT_NAME || '';
            dlContent.price = window.PRODUCT_PRICE || '';
        }

        window.LC_API.on_chat_window_opened = function () {
            window.dataLayer.push({ ...dlContent });
        };

        window.LC_API.on_chat_started = function (data) {
            // used in checkoutConfirm datalayer
            Cookies.set('last_agent_name', data.name);
        };
    }
});
